import { UserRol } from '@enums/UserRol'
import type { UserData } from '../models/UserData'

export const UserDataService = {
  getUserData: (): UserData | null => {
    const userDataStorage = localStorage.getItem('userData')
    let userData: UserData | null = null
    if (userDataStorage) {
      try {
        userData = JSON.parse(atob(userDataStorage))
      } catch (err) {
        // O han modificado la string o es la migracion
      }
    }
    return userData
  },

  hasUserData() {
    return !!this.getUserData()
  },

  saveUserData: (userData: UserData) => {
    localStorage.setItem('userData', btoa(JSON.stringify(userData)))
  },

  clearUserData: () => {
    localStorage.removeItem('userData')
  },

  getOrganizationId: () => {
    return UserDataService.getUserData()?.organization.ID
  },

  getOrganizationExtent: () => {
    return UserDataService.getUserData()?.organization.EXTENT
  },

  getPermissions: () => {
    return UserDataService.getUserData()?.permisos || []
  },

  getRol: () => {
    return UserDataService.getUserData()?.idRol
  },

  isAnalist: () => {
    return (
      UserDataService.getRol() == UserRol.ADMINISTRADOR ||
      UserDataService.getRol() == UserRol.MANAGER
    )
  },

  getDefaultModel: () => {
    return UserDataService.getUserData()?.organization.DEFAULT_MODEL
  },

  getReportConfig: () => {
    return UserDataService.getUserData()?.reportConfig || null
  }
}
